import {
  createSlice,
  createAsyncThunk,
  PayloadAction,
  current,
} from "@reduxjs/toolkit";
import {LOAI_PHIEU_KHO, TT_PHIEU_KHO, LOAI_FORM, tabKeys} from "types/enums";

export interface State {
  activeTabAllocation: any;
  selectedRecord: any; // bản ghi phiếu đc chọn
  loading: boolean;
  searchForm: any;
}

const initialState: State = {
  activeTabAllocation: tabKeys.PHARMACY_STORE.ALLOCATION_LIST,
  selectedRecord: null,
  loading: false,
  searchForm: null,
};

export const allocationMedicineSlice = createSlice({
  name: "allocationMedicine",
  initialState: initialState,
  reducers: {
    setSearchForm: (state = initialState, action: PayloadAction<any>) => {
      return {...state, searchForm: action.payload};
    },
    setActiveTabAllocation: (
      state = initialState,
      action: PayloadAction<any>
    ) => {
      return {...state, activeTabAllocation: action.payload};
    },
    setListPharmacyGroup: (
      state = initialState,
      action: PayloadAction<any>
    ) => {
      return {...state, setListPharmacyGroup: action.payload};
    },

    setSelectedRecord: (state = initialState, action: PayloadAction<any>) => {
      return {...state, selectedRecord: action.payload};
    },

    setLoading: (state = initialState, action: PayloadAction<any>) => {
      return {...state, loading: action.payload};
    },
  },
});

export const {
  setSearchForm,
  setActiveTabAllocation,
  setLoading,
  setSelectedRecord,
} = allocationMedicineSlice.actions;

export default allocationMedicineSlice.reducer;
